module.exports = __webpack_public_path__ + "img/BannerHomePro.d30942db.webp";